import React, {
	Component
} from 'react';

import { store } from '../stores/mainStore';
import styled from 'styled-components';
import {observer} from 'mobx-react';
// import {observable} from 'mobx';
import { motion } from 'framer-motion';

import {times, max} from 'lodash';
import { ButtonMover } from './Buttons';
import { observable } from 'mobx';
import { integration } from '../integration';


const RewardBanner = styled(motion.div)`
	position: absolute;
	top: 15vw;
	margin: 0 !important;
	padding: 0;
	height: 100vh;
	z-index: 2000;
	width: 100vw;
`

const Inner = styled.div`
	position: relative;
	height: 100%;
	width: 100%;
`

const Heart = styled(motion.img)`
	width: 10vw;
	position: absolute;
	z-index: 2500;
`
const RewardPanel = styled(motion.div)`
	width: 90vw;
	height: 80vw;
	left: 5vw;
	position: absolute;
	background-size: 100% auto;
	& .heartCount {
		position: absolute;
		top: 40vw;
		left: -0.5vw;
		font-size: 9vw;
		color: white;
		text-align: center;
		width: 100%;
		line-height: 0.8em;
		text-shadow: 0.5vw 0.3vw 0.3vw black;
		& > span {
			font-size: 6vw;
		}
	}
	& .watch-button {
		position: absolute;
		top: 61vw;
		left: 20vw;
		width: 50vw;
		& img {
			width: 50vw;
		}
	}
	& .close {
		position: absolute;
		top: -5vw;
		right: -5vw;
		width: 13vw;
		& img {
			width: 13vw;
		}
	}
`


@observer
export class TopBarPurchaseComplete extends Component {

	@observable showHearts = false;

	constructor(props){
		super(props);
		integration.postAnalyticsEvent(`store_purchase_success`, `economy`);
		store.user.updateHearts()
		.then(() => {
			store.purchasedHearts = store.user.animateToHearts - store.user.hearts;
		});
		store.modal = '';
	}

	onHeartsComplete = () => {
		store.user.heartAnimComplete();
		setTimeout(this.close, 1000);
		if(this.props.onHeartsComplete){
			this.props.onHeartsComplete();
		}
		if(store.topBar.hide === true)
			window.manager.updateHeartInfo();
	}

	redeem = () => {
		this.showHearts = true;
		integration.postAnalyticsEvent(`store_purchase_redeem`, `economy`);
		integration.postAnalyticsEvent(`reward_purchase`, `economy`, store.purchasedHearts);
		window.manager.playAudio("RewardsPopupStars");
	}

	close = () => {
		window.manager.playAudio("poopPop");
		store.purchaseComplete = false;
	}

	render(){
		var delayBeforeFirstHeart = 1;
		var delayIncrement = 0;
		return (
			<React.Fragment key="countdown-ad-hearts">
				<RewardBanner key="achievement">
					<Inner>
						<RewardPanel
							style={{
								backgroundImage: `url("/assets/languages/${store.settings.language}/box_purchase.png")`
							}}
							initial={{y: '-80vw', opacity: 1}}
							exit={{
								y: '-80vw',
								opacity: 0,
								transition: {type: 'tween', duration: 0.5}
							}}
							animate={{y: store.aspectIs('Tablet') ? '25vw' : '50vw', opacity: 1}}
							transition={{
								y: {type: "spring", stiffness: 300, damping: 25, mass: 1.5}
							}}
						>
							<Inner>
								{store.purchasedHearts > 0 && <div className="heartCount">{store.purchasedHearts}</div>}
								{store.purchasedHearts > 0 && !this.showHearts && (
									<div className="watch-button">
										<ButtonMover onClick={this.redeem}>
											<img alt="watch" src={`/assets/languages/${store.settings.language}/btn_redeem.png`}/>
										</ButtonMover>
									</div>
								)}
							</Inner>
						</RewardPanel>
					</Inner>
				</RewardBanner>
				{this.showHearts && times(store.purchasedHearts, (n) => {
					var d = max([(0.15 - (n * 0.01)),0.03]);
					delayIncrement += d;
					return (
						<Heart
							onAnimationComplete={n + 1 === store.purchasedHearts ? this.onHeartsComplete : null}
							key={`star-${n}`}
							initial={{x: '45vw', y: store.aspectIs('Tablet') ? '75vw' : '105vw', scale: 0}}
							animate={{x: '74vw', y: '-1vw', scale: [0,1,1,0]}}
							transition={{
								default: {delay: delayBeforeFirstHeart + delayIncrement, duration: 0.8, ease: 'easeInOut'}
							}}
							src="/assets/hud/hud_icon_heart.png"
						/>
					);
				})}
			</React.Fragment>
		)
	}
}
